import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { ISinhVienUpdateDanhBaRequest } from "../../../model/request/sinh-vien/ISinhVienUpdateDanhBaRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";

import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhBaSinhVienActionsObj = {
  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_TRANG_THAI_HOC: [] as number[],
  CHANGE_DOI_TUONG: [] as number[],
  CHANGE_DOT_NHAP_HOC: 0,
  CHANGE_SINHVIEN_SELECTED_IDS: [] as string[],

  CHANGE_STATUS: {} as eReducerStatusBase,

  LOAD_HOCSINH_START: {} as ISinhVienSelectByLopsRequest,
  LOAD_HOCSINH_SUCCESS: {} as IStuHoSoSinhVienViewModel[],
  LOAD_HOCSINH_ERRR: "",

  SHOW_EDIT_MODAL: {} as IStuHoSoSinhVienViewModel | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as ISinhVienUpdateDanhBaRequest,
  SAVE_SUCCESS: {} as ISinhVienUpdateDanhBaRequest,
  SAVE_ERROR: "",

  CHANGE_SEARCH_KEY: "",

  ADD_SINHVIEN_TO_LIST: {} as IStuHoSoSinhVienViewModel,
};

export const eDanhBaSinhVienActionIds = generateActionTypeIds(
  eDanhBaSinhVienActionsObj,
  "DANH_BA_SINH_VIEN",
);
export type IDanhBaSinhVienActionTypes = IGenericActionType<
  typeof eDanhBaSinhVienActionsObj,
  "DANH_BA_SINH_VIEN"
>;
